import { isObject } from '../../../utils/isDefined';

const mapAddress = selected => {
  const address = selected.adresse;

  if (!isObject(address)) {
    return {};
  }

  const vejnavn = address.husnummer?.vejnavn || '';
  const husnr = address.husnummer?.husnummertekst || '';
  const postnr = address.husnummer?.postnummer?.postnr || '';
  const postnrnavn = address.husnummer?.postnummer?.navn || '';
  const supplerendebynavn = address.husnummer?.supplerendebynavn?.navn || '';
  const etage = address.etagebetegnelse || '';
  const dør = address.doerbetegnelse || '';
  const kommunekode = address.husnummer?.navngivenvejkommunedel?.kommune || '';
  const vejkode = address.husnummer?.navngivenvejkommunedel?.vejkode || '';
  const id = address.id_lokalid || '';

  return {
    vejnavn,
    husnr,
    postnr,
    postnrnavn,
    supplerendebynavn,
    etage,
    dør,
    kommunekode,
    vejkode,
    id
  };
};

export default mapAddress;
